import { defineComponent as _defineComponent } from 'vue'
import AppAlerts from './components/AppAlerts.vue';
  import { useAuthStore } from './stores/authStore';
  import { USER_TOKEN } from '@/config/constants';
  import { useScriptTag } from '@vueuse/core';
  import { useStateStore } from './stores/StateStore';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {
  __expose();

  const stateStore = useStateStore();
  useScriptTag('https://js.stripe.com/v3/', () => stateStore.setLoadedStripeScript(true));
  const authStore = useAuthStore();
  const token = localStorage.getItem(USER_TOKEN);
  if (token && token !== 'null') {
    authStore.setUserToken(token);
  }

const __returned__ = { stateStore, authStore, token, AppAlerts, get useAuthStore() { return useAuthStore }, get USER_TOKEN() { return USER_TOKEN }, get useScriptTag() { return useScriptTag }, get useStateStore() { return useStateStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})